module.exports = __webpack_public_path__ + "static/outlook_local_tasks-ec72a2507a2fa51559a724602779a73f.png";